import React from 'react';

interface ThankYouProps {
  eventName: string;
  onReview?: () => void;
  onReset?: () => void;
}

export default function ThankYou({ eventName, onReview, onReset }: ThankYouProps) {
  return (
    <div className="page thank-you">
      <div className="thank-you__card">
        <h1 className="thank-you__title">Thank you</h1>
        <p className="thank-you__message">
          Your feedback for <strong>{eventName}</strong> has been recorded. We really appreciate you taking the time.
        </p>
        <div className="thank-you__actions">
          {onReview && (
            <button type="button" className="btn btn--secondary" onClick={onReview}>
              Review my answers
            </button>
          )}
          {onReset && (
            <button type="button" className="btn btn--ghost" onClick={onReset}>
              Start over (reset survey)
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
